import React from 'react';
import { motion } from 'framer-motion';
export function WhyTalking() {
  const cards = [{
    emoji: '🦷',
    title: 'Oral Microbiome Awareness',
    desc: 'Learn about the balance between beneficial and unwanted bacteria and why it matters.'
  }, {
    emoji: '🍬',
    title: 'Hidden Sugar Exposure',
    desc: 'Discover surprising sources of sugar exposure that many people overlook.'
  }, {
    emoji: '📘',
    title: 'Easy-To-Follow Educational Format',
    desc: 'No complicated science jargon. Just practical information explained in plain English.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-292">
      <div className="max-w-5xl mx-auto px-6" data-id="element-293">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-slate-900 mb-14 text-center" data-id="element-294">
          Why Readers Are Talking About This Guide
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-295">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-white rounded-2xl p-8 shadow-md border border-slate-100 text-center" data-id="element-296">
              <div className="text-5xl mb-5" data-id="element-297">{card.emoji}</div>
              <h3 className="font-playfair font-bold text-slate-900 text-xl mb-3 leading-tight" data-id="element-298">
                {card.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-299">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}